<template>
  <!-- Page Content -->
  <div class="whole-page-long">
    <div
      class="left-sidebar-front-div"
      v-if="Analytics['userSelections']['visibleLeft']"
      @click="
        Analytics['userSelections']['visibleLeft'] = !Analytics[
          'userSelections'
        ]['visibleLeft']
      "
    ></div>

    <!--contents-->
    <div class="h-100 d-flex flex-column">
      <div class="row f-row h-100">
        <LeftSidebarAnalyticsCom
          :selectedAnalysis="Analytics['userSelections']['selectedAnalysis']"
          :selectedAnalysisParent="
            Analytics['userSelections']['selectedAnalysisParent']
          "
          :visibleLeft="Analytics['userSelections']['visibleLeft']"
          :selectedChildName="computedSelectedChildName"
          @eventOnLeftSidebarAnalysis="onLeftSidebarAnalysis"
          @eventOnUserClickLeftSidebarShow="onUserClickLeftSidebarShow"
          @onLeftSidebarAnalysisScenarios="onLeftSidebarAnalysisScenarios"
          @eventOnSidebarItemsChange="onSidebarItemsChange"
        />
        <div class="largeBox">
          <div class="row f-row h-100 justify-content-center">
            <div class="col col-12 h-100 text-center">
              <MonthlyValuationCmdty
                v-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'valuation'
                "
                :Analytics="Analytics"
                :companyParametersReady="companyParametersReady"
                :dataFilters="Analytics['valuation']['dataFilters']"
                :processData="processData"
                @eventOnUserAccountingValuate="onUserAccountingValuate"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFilter="onUserFilterValuation"
                @eventOnUserFinalDate="onUserFinalDate"
                @eventOnUserFinalSpot="onUserFinalSpot"
                @eventOnUserInitialDate="onUserInitialDate"
                @eventOnUserInitialSpot="onUserInitialSpot"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserUnderlying="onUserUnderlying"
              />
              <ManagementConsolidations
                v-else-if="
                  Analytics['userSelections']['selectedAnalysisParent'] ===
                    'contractManagement'
                "
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :companyParametersReady="companyParametersReady"
                :processData="processData"
                :selectedTable="Analytics['userSelections']['selectedTable']"
                :selectedUnit="Analytics['userSelections']['selectedUnit']"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchManagementData="onUserFetchManagementData"
                @eventOnUserFetchExpand="onUserFetchExpand"
                @eventOnFilteredData="onFilteredData"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserSelectUnit="onUserSelectUnit"
                @eventOnUserSpotChange="onUserSpotChange"
              />
              <VisualizationChartsTable
                v-else-if="
                  ['scenario'].includes(
                    Analytics['userSelections']['selectedAnalysis'],
                  )
                "
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :companyParametersReady="companyParametersReady"
                :eventElement="eventElement"
                :fixing_type="fixing_type"
                :isCurrency="false"
                :processData="processData"
                :screenWidth="screenWidth"
                @eventOnClientExpandSidebar="onClientExpandSidebar"
                @eventOnFilteredData="onFilteredData"
                @eventOnMktRefChange="onMktRefChange"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchData="onUserFetchData"
                @eventOnUserFetchExpand="onUserFetchExpand"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserNormalizeQty="onUserNormalizeQty"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserShow="onUserShow"
                @eventOnUserShowDetails="onUserShowDetails"
                @eventOnUserSpotChange="onUserSpotChange"
                @eventOnUserYear="onUserYear"
                @eventOnUserZoom="onUserZoom"
                @resizeCharts="resizeCharts"
              />
              <AnalyticsPortfolio
                v-else-if="
                  false &&
                    ['scenarios'].includes(
                      Analytics['userSelections']['selectedAnalysis'],
                    ) &&
                    Analytics['userSelections'][
                      'selectedAnalysisParent'
                    ].includes('scenario')
                "
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :companyParametersReady="companyParametersReady"
                :processData="processData"
                :screenWidth="screenWidth"
                :eventElement="eventElement"
                @eventOnClientExpandSidebar="onClientExpandSidebar"
                @eventOnFilteredData="onFilteredData"
                @eventOnMktRefChange="onMktRefChange"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchData="onUserFetchData"
                @eventOnUserFetchExpand="onUserFetchExpand"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserNormalizeQty="onUserNormalizeQty"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserShow="onUserShow"
                @eventOnUserShowDetails="onUserShowDetails"
                @eventOnUserSpotChange="onUserSpotChange"
                @eventOnUserYear="onUserYear"
                @eventOnUserZoom="onUserZoom"
                @resizeCharts="resizeCharts"
              />
              <CommodityScenarios
                v-else-if="
                  [
                    'scenario',
                    'scenarios',
                    'strategies',
                    'derivatives',
                    'providers',
                    'clients',
                    'counterparty',
                  ].includes(Analytics['userSelections']['selectedAnalysis']) &&
                    Analytics['userSelections'][
                      'selectedAnalysisParent'
                    ].includes('scenario')
                "
                :Analytics="Analytics"
                :colorTheme="colorTheme"
                :companyParametersReady="companyParametersReady"
                :processData="processData"
                :screenWidth="screenWidth"
                :eventElement="eventElement"
                @eventOnClientExpandSidebar="onClientExpandSidebar"
                @eventOnFilteredData="onFilteredData"
                @eventOnMktRefChange="onMktRefChange"
                @eventOnUserAsset="onUserAsset"
                @eventOnUserCompany="onUserCompany"
                @eventOnUserFetchData="onUserFetchData"
                @eventOnUserFetchExpand="onUserFetchExpand"
                @eventOnUserFilter="onUserFilter"
                @eventOnUserNormalizeQty="onUserNormalizeQty"
                @eventOnUserPortfolio="onUserPortfolio"
                @eventOnUserShow="onUserShow"
                @eventOnUserShowDetails="onUserShowDetails"
                @eventOnUserSpotChange="onUserSpotChange"
                @eventOnUserYear="onUserYear"
                @eventOnUserZoom="onUserZoom"
                @resizeCharts="resizeCharts"
              />
              <div
                v-else-if="
                  Analytics['userSelections']['selectedAnalysis'] ===
                    'originDestiny'
                "
                class="justify-content-center vert-align no_nav_height"
                style="top: 60px!important; width: 100%!important; "
              >
                <div class="col col-12 text-center inh no_nav_height">
                  <div class="row f-row mb-2">
                    <div
                      class="markets-chart-title col col-12"
                      style="text-align: center!important;"
                    >
                      ORIGIN <i class="fa fa-arrow-right"></i> DESTINY
                    </div>
                  </div>
                  Coming soon...
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AnalyticsPortfolio from "@/components/analytics/AnalyticsPortfolio";
import CommodityScenarios from "@/components/analytics/CommodityScenarios";
import LeftSidebarAnalyticsCom from "@/components/analytics/LeftSidebarAnalyticsCom";
import ManagementConsolidations from "@/components/analytics/ManagementConsolidations.vue";
import MonthlyValuationCmdty from "./MonthlyValuationCmdty";
import VisualizationChartsTable from "@/components/analytics/VisualizationChartsTable.vue";
import {
  AnalyticsCommodity,
  managementFields,
} from "@/_core/data/Analytics/AnalyticsCommodity";
import { AnalyticsManager } from "@/_core/data/Analytics/AnalyticsManager";
import { getSpotData } from "@/_core/data/api_calls/getSpotData";
import { saveUserPreferences } from "@/_core/data/SaveToDB";
import { initAnalyticsPreferences } from "../../_core/data/Analytics/AnalyticsGeneral";
import { selectAll } from "d3";

export default {
  name: "CommodityBeta",
  components: {
    AnalyticsPortfolio,
    CommodityScenarios,
    LeftSidebarAnalyticsCom,
    ManagementConsolidations,
    MonthlyValuationCmdty,
    VisualizationChartsTable,
  },
  props: {
    analyticsPreferences: { required: true, default: () => {} },
    colorTheme: { required: true, type: Boolean, default: true },
    commoditySpecs: { required: true },
    companies: {
      required: true,
      default: () => [{ id: 0, company_name: "N.A." }],
    },
    companyParametersReady: { required: true, type: Boolean, default: false },
    countrySpecs: { required: true },
    optionTypes: { required: true, default: () => [] },
    processData: { required: true },
  },
  data() {
    return {
      Analytics: AnalyticsManager.defaultAnalytics(this.filterComm),
      commodityNumber: null,
      eventElement: {},
      filterComm: {
        base: "createAndConstraint",
        bonus: "createAndConstraint",
        commodity: "createInConstraint",
        commodity_unit: "createInConstraint",
        continuation_month: "createAndConstraint",
        contract_month_year: "createInConstraint",
        country_of_destination: "createInConstraint",
        end_product: "createInConstraint",
        fixation_date: "createDateIsConstraint",
        fixation_status: "createInConstraint",
        end_product_str: "createInConstraint",
        fk_id_end_product: "createInConstraint",
        fk_id_provider: "createInConstraint",
        fk_idincoterms: "createInConstraint",
        futures: "createInConstraint",
        percent_bonus: "createAndConstraint",
        pricing_method: "createInConstraint",
        provider: "createAndConstraint",
        quantity: "createAndConstraint",
        ratio: "createAndConstraint",
      },
      hasBootstrapped: false,
      initCommodityDate: new Date(
        new Date().setFullYear(new Date().getFullYear() - 11),
      ),
      initManagementDate: new Date(new Date().getFullYear() - 1, 0, 1),
      isApplyingRoute: false,
      isUpdatedRoute: false,
      itemsLeftSidebar: [],
      lCall: require("@/assets/images/lCall.svg"),
      lCallOff: require("@/assets/images/derivUpOff.svg"),
      lCallOn: require("@/assets/images/lCall.svg"),
      lFwd: require("@/assets/images/lFwd.svg"),
      lFwdOff: require("@/assets/images/fwdUpOff.svg"),
      lFwdOn: require("@/assets/images/lFwd.svg"),
      lPut: require("@/assets/images/lPut.svg"),
      lPutOff: require("@/assets/images/derivUpOff.svg"),
      lPutOn: require("@/assets/images/lPut.svg"),
      pendingRoute: null,
      sCall: require("@/assets/images/sCall.svg"),
      sCallOff: require("@/assets/images/derivDownOff.svg"),
      sCallOn: require("@/assets/images/sCall.svg"),
      screenWidth: 0,
      sFwd: require("@/assets/images/sFwd.svg"),
      sFwdOff: require("@/assets/images/fwdDownOff.svg"),
      sFwdOn: require("@/assets/images/sFwd.svg"),
      spot: null,
      sPut: require("@/assets/images/sPut.svg"),
      sPutOff: require("@/assets/images/derivDownOff.svg"),
      sPutOn: require("@/assets/images/sPut.svg"),
      today: new Date(),
    };
  },
  created() {
    document.title = "Analytics | Cmdty";
    this.pendingRoute = this.$route;

    const storePrefs = this.$store.getters["user_preferences/analyticsChoices"];
    const { analytics_preferences, prefsChanged } = initAnalyticsPreferences(
      storePrefs,
      "commodity",
    );

    this.analyticsPreferences = analytics_preferences;

    if (prefsChanged) {
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        analytics_preferences,
      );
      this.saveUserPrefs();
    }
  },
  mounted() {
    this.updateScreenWidth();
    this.bootstrapFromRoute();
  },
  computed: {
    fixing_type() {
      return Array.isArray(this.Analytics["userSelections"]["selectedAsset"]) &&
        this.Analytics["userSelections"]["selectedAsset"].length > 0 &&
        this.Analytics["userSelections"]["selectedAsset"][0]
        ? this.Analytics["userSelections"]["selectedAsset"][0].fixing_type
        : null;
    },
    analyticsReady() {
      return (
        this.companyParametersReady === true &&
        this.Analytics &&
        typeof this.Analytics.updateSelectedCompanies === "function"
      );
    },
    loadingExpoHedges() {
      const { expo, hedges } = this.Analytics["loading"];
      return expo || hedges;
    },
    computedSelectedChildName() {
      const selectedAnalysisParent = this.Analytics.userSelections
        .selectedAnalysisParent;
      const selectedAnalysis = this.Analytics.userSelections.selectedAnalysis;

      if (selectedAnalysisParent === "contractManagement") {
        return {
          selectedAnalysis: this.Analytics.userSelections.selectedTable,
          selectedAnalysisParent: selectedAnalysisParent,
        };
      } else if (selectedAnalysisParent === "scenario") {
        return { selectedAnalysis, selectedAnalysisParent: "scenarios" };
      } else if (selectedAnalysisParent && selectedAnalysis) {
        return { selectedAnalysis, selectedAnalysisParent };
      }

      return null;
    },
  },
  watch: {
    companyParametersReady(val) {
      if (val === true) this.bootstrapFromRoute();
    },
    loadingExpoHedges(val) {
      if (val === false) {
        const { hedges } = this.Analytics["rawData"];
        if (hedges.length > 0) {
          this.getSpotFromHedges();
        } else {
          Object.assign(this.Analytics["loading"], {
            topographyCalcs: false,
            strategies: false,
            derivatives: false,
          });
        }
      }
    },
    optionTypes(val) {
      Object.assign(this.Analytics, {
        optionTypes: val,
      });
    },
    $route: {
      handler(newRoute) {
        if (this.isUpdatedRoute) {
          this.isUpdatedRoute = false;
          return;
        }

        if (this.isApplyingRoute) return;
        if (!this.analyticsReady) return;
        if (this.loadingExpoHedges !== false) return;

        this.validateAndApplyRouteParams(newRoute);
      },
      immediate: false,
      deep: true,
    },
  },
  methods: {
    saveUserPrefs() {
      this.$store.dispatch(
        "user_preferences/updateAnalyticsChoices",
        this.analyticsPreferences,
      );
      saveUserPreferences(this);
    },
    bootstrapFromRoute() {
      if (this.hasBootstrapped) return;
      if (!this.companyParametersReady) return;

      this.hasBootstrapped = true;
      this.isApplyingRoute = true;

      this.initiate();

      this.$nextTick(() => {
        const routeToApply = this.pendingRoute || this.$route;
        this.validateAndApplyRouteParams(routeToApply);

        this.isApplyingRoute = false;

        if (this.hasValidFilters()) {
          this.onUserFetchData();
        }
      });
    },
    validateAndApplyRouteParams(route) {
      const { query, params } = route;

      if (params.productType === "commodity") {
        if (route.name === "analytics-valuation") {
          this.Analytics.userSelections.selectedAnalysis = "valuation";
          this.Analytics.userSelections.selectedAnalysisParent = "valuation";
        } else if (route.name.includes("analytics-management")) {
          this.Analytics.userSelections.selectedAnalysisParent =
            "contractManagement";
          this.Analytics.userSelections.selectedAnalysis = "contractManagement";
          this.Analytics.userSelections.selectedTable = route.name
            .replace("analytics-management-", "")
            .toLowerCase();
        } else if (route.name.includes("analytics-scenarios")) {
          this.Analytics.userSelections.selectedAnalysisParent = "scenario";
          this.applyScenarioRoute(route.name);

          this.applyScenarioFilters(query);
        } else {
          // Unrecognized route, update route
          this.updateRoute();
        }
      } else {
        // If the user did not write a route or it's not a valid route
        this.isApplyingRoute = false;
        this.updateRoute();
      }
    },
    applyScenarioFilters(query) {
      if (!query.companies || !query.portfolios || !query.commodities) {
        this.updateRoute();
        return;
      }

      if (query.companies) {
        const companyNames = query.companies.split(",");
        const validCompanies = this.companies.filter((c) =>
          companyNames.includes(c.company_name),
        );

        if (validCompanies.length > 0) {
          const portfolios = this.filterPortfoliosByNames(
            validCompanies,
            query.portfolios,
          );
          Object.assign(this.Analytics.userSelections, {
            portfolios: this.Analytics.getPortfolios(validCompanies),
          });
          const assets = this.filterAssetsByNames(
            portfolios,
            query.commodities,
          );

          this.onUserCompany(validCompanies, portfolios, assets);
        } else {
          console.warn("No se encontraron compañías válidas:", companyNames);
          return;
        }
      }

      if (this.hasValidFilters()) {
        this.onUserFetchData();
      }
    },
    filterPortfoliosByNames(companies, portfolioQuery) {
      const portfolios = this.Analytics.getPortfolios(companies);
      const filterPortfolios = portfolios.filter((p) =>
        portfolioQuery.split(",").includes(p.name),
      );

      return filterPortfolios || [];
    },
    filterAssetsByNames(portfolios, assetQuery) {
      const assetPK = this.Analytics.getAssets(portfolios, true);
      const listAssets = [];

      assetPK.forEach((pk) => {
        listAssets.push(
          this.Analytics.companyParameters.endProducts.filter(
            (d) =>
              d.pk_id_end_product === pk &&
              assetQuery.split(",").includes(d.product_name),
          )[0],
        );
      });

      return listAssets.filter((a) => a != null);
    },
    applyScenarioRoute(routeName) {
      const routeMap = {
        "analytics-scenarios-portfolio": "portfolio",
        "analytics-scenarios-strategies": "strategies",
        "analytics-scenarios-derivatives": "derivatives",
        "analytics-scenarios-providers": "providers",
        "analytics-scenarios-clients": "clients",
        "analytics-scenarios-counterparty": "counterparty",
      };

      const analysis = routeMap[routeName];
      if (analysis) {
        if (routeMap[routeName] === "portfolio") {
          this.Analytics.userSelections.selectedAnalysis = "scenario";
        } else {
          this.Analytics.userSelections.selectedAnalysis = analysis;
        }
      }
    },
    hasValidFilters() {
      const {
        selectedCompanies,
        selectedPortfolios,
        selectedAsset,
      } = this.Analytics.userSelections;

      return (
        selectedCompanies?.length > 0 &&
        selectedPortfolios?.length > 0 &&
        selectedAsset?.length > 0
      );
    },
    getCommonQueryFilters() {
      const selections = this.Analytics["userSelections"];

      const selectedCompanies = selections["selectedCompanies"] || [];
      const selectedPortfolios = selections["selectedPortfolios"] || [];
      const selectedUnderlying = selections["selectedAsset"] || [];

      // Extraer y filtrar IDs válidos
      const companies = selectedCompanies
        .filter((c) => c && c.pk_idcompany != null)
        .map((c) => c.company_name);

      const portfolios = selectedPortfolios
        .filter((p) => p && p.pk != null)
        .map((p) => p.name);

      const commodities = selectedUnderlying
        .filter((u) => u && u.pk_id_end_product != null)
        .map((u) => u.product_name);

      const filters = {};
      filters.companies = companies.join(",");
      filters.portfolios = portfolios.join(",");
      filters.commodities = commodities.join(",");

      return filters;
    },
    validateSelectedAnalysisPreferences() {
      return (
        this.analyticsPreferences.selectedAnalysis &&
        this.analyticsPreferences.selectedAnalysisParent
      );
    },
    updateAnalysisByPreferences() {
      if (this.validateSelectedAnalysisPreferences()) {
        this.Analytics.userSelections.selectedAnalysis = this.analyticsPreferences.selectedAnalysis;
        this.Analytics.userSelections.selectedAnalysisParent = this.analyticsPreferences.selectedAnalysisParent;
        this.Analytics.userSelections.selectedTable = this.analyticsPreferences.selectedTable;
      }
    },
    updateRoute() {
      if (this.isApplyingRoute) return;

      this.isUpdatedRoute = true;

      let routeName = null;
      const selectedAnalysis = this.Analytics["userSelections"][
        "selectedAnalysis"
      ];
      const selectedAnalysisParent = this.Analytics["userSelections"][
        "selectedAnalysisParent"
      ];

      if (selectedAnalysis === "valuation") {
        routeName = "analytics-valuation";
      } else if (selectedAnalysisParent === "contractManagement") {
        routeName = this.selectedRouteNameContractManagement();
      } else if (selectedAnalysisParent.includes("scenario")) {
        routeName = this.selectedRouteNameAnalysisScenarios();
      }

      if (!routeName) {
        console.warn("No se pudo determinar el nombre de la ruta");
        return;
      }

      const params = {
        productType: "commodity",
      };
      const query = {};

      if (routeName === "analytics-valuation") {
        const commonFilters = this.getCommonQueryFilters();

        if (!commonFilters) {
          console.warn("No se pudieron obtener filtros válidos para valuation");
          return;
        }

        Object.assign(query, commonFilters);
      } else if (selectedAnalysisParent === "contractManagement") {
        const commonFilters = this.getCommonQueryFilters();

        if (!commonFilters) {
          console.warn(
            "No se pudieron obtener filtros válidos para contract management",
          );
        } else {
          Object.assign(query, commonFilters);
        }
      } else if (selectedAnalysisParent.includes("scenario")) {
        const commonFilters = this.getCommonQueryFilters();

        if (!commonFilters) {
          console.warn("No se pudieron obtener filtros válidos para scenarios");
        } else {
          Object.assign(query, commonFilters);
        }
      }

      const routeConfig = {
        name: routeName,
        params,
        query,
      };

      if (
        this.$route.name !== routeConfig.name ||
        JSON.stringify(this.$route.params) !==
          JSON.stringify(routeConfig.params) ||
        JSON.stringify(this.$route.query) !== JSON.stringify(routeConfig.query)
      ) {
        this.$router.push(routeConfig).catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            console.error("Error al actualizar la ruta:", err);
          }
        });
      }

      this.updateLeftSideBar(this.$route.name);
      this.syncPreferencesFromAnalytics();
      this.saveUserPrefs();
    },
    selectedRouteNameContractManagement() {
      switch (this.Analytics["userSelections"]["selectedTable"]) {
        case "strategies":
          return "analytics-management-strategies";
        case "contracts":
          return "analytics-management-contracts";
        case "date_2":
          return "analytics-management-date_2";
        case "clients":
          return "analytics-management-clients";
        case "suppliers":
          return "analytics-management-suppliers";
        default:
          return "analytics-management-strategies";
      }
    },
    selectedRouteNameAnalysisScenarios() {
      switch (this.Analytics["userSelections"]["selectedAnalysis"]) {
        case "scenario":
        case "scenarios":
          return "analytics-scenarios-portfolio";
        case "strategies":
          return "analytics-scenarios-strategies";
        case "derivatives":
          return "analytics-scenarios-derivatives";
        case "providers":
          return "analytics-scenarios-providers";
        case "clients":
          return "analytics-scenarios-clients";
        case "counterparty":
          return "analytics-scenarios-counterparty";
        default:
          return "analytics-scenarios-portfolio";
      }
    },
    updateLeftSideBar(name) {
      if (this.itemsLeftSidebar.length > 0) {
        this.itemsLeftSidebar.forEach((item) => {
          if (item.routeName === name) {
            Object.assign(this.userSelections, {
              selectedAnalysis: item.nameEvent,
            });
          }
        });
      }
    },
    onSidebarItemsChange(items) {
      Object.assign(this, {
        itemsLeftSidebar: items,
      });
    },
    getSpotFromHedges() {
      Object.assign(this.Analytics["loading"], {
        spot: true,
      });
      let spot = null;
      let hLen = this.Analytics["rawData"]["hedges"].length;
      if (hLen > 0) {
        spot =
          this.Analytics["rawData"]["hedges"].find((obj) => obj.spot != null)
            ?.spot ?? null;
        Object.assign(this.Analytics["rawData"], {
          spot: spot,
        });
      }

      if (spot == null) {
        let _this = this;
        this.commodityNumber = this.Analytics["userSelections"][
          "selectedUnderlying"
        ][0]["pk_idcommodity"];
        getSpotData(
          this,
          "spot",
          "updatedAt",
          "showLoadingValuating",
          "commodity",
        )
          .then((data) => {
            Object.assign(_this.Analytics["rawData"], {
              spot: +data[0]["last_price"],
            });
            Object.assign(_this.Analytics["loading"], {
              spot: false,
            });
          })
          .catch(function(error) {
            Object.assign(_this.Analytics["loading"], {
              spot: false,
            });
            console.error(error);
          });
      } else {
        Object.assign(this.Analytics["loading"], {
          spot: false,
        });
      }
    },
    initiate() {
      if (this.isUpdatedRoute) {
        const prevSelectedAnalysisParent = this.Analytics.userSelections
          .selectedAnalysisParent;
        const prevSelectedAnalysis = this.Analytics.userSelections
          .selectedAnalysis;
        this.Analytics = AnalyticsManager.defaultAnalytics(this.filterComm);

        this.$nextTick(() => {
          if (prevSelectedAnalysisParent) {
            this.Analytics.userSelections.selectedAnalysisParent = prevSelectedAnalysisParent;
          }
          if (prevSelectedAnalysis) {
            this.Analytics.userSelections.selectedAnalysis = prevSelectedAnalysis;
          }
        });
      }

      this.Analytics = new AnalyticsCommodity({
        analyticsPreferences: this.analyticsPreferences,
        assetType: "commodity",
        companies: this.companies,
        companyParameters: JSON.parse(
          JSON.stringify(this.$store.state.companyParameters),
        ),
        images: {
          lCallOff: this.lCallOff,
          lCallOn: this.lCallOn,
          lFwd: this.lFwd,
          lFwdOff: this.lFwdOff,
          lFwdOn: this.lFwdOn,
          lPut: this.lPut,
          lPutOff: this.lPutOff,
          lPutOn: this.lPutOn,
          sCall: this.sCall,
          sCallOff: this.sCallOff,
          sCallOn: this.sCallOn,
          sFwd: this.sFwd,
          sFwdOff: this.sFwdOff,
          sFwdOn: this.sFwdOn,
          sPut: this.sPut,
          sPutOff: this.sPutOff,
          sPutOn: this.sPutOn,
        },
        processData: this.processData,
        underlyingSpecs: this.commoditySpecs,
        customFilters: this.filterComm,
      });

      Object.assign(this.Analytics, {
        managementFields: managementFields,
      });

      const storePrefs =
        this.$store.getters["user_preferences/analyticsChoices"] ||
        this.$store.state.user_preferences?.all?.items?.analytics_choices;

      let saveUserPref = this.Analytics.initStoreCompPortAsset(storePrefs);

      if (saveUserPref) {
        this.updateAnalysisByPreferences();
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }

      if (this.optionTypes.length > 0) {
        Object.assign(this.Analytics, {
          optionTypes: this.optionTypes,
        });
      }

      this.selectionStr();
    },
    syncPreferencesFromAnalytics() {
      const {
        selectedCompanies,
        selectedPortfolios,
        selectedAsset,
        selectedUnderlying,
        selectedAnalysis,
        selectedAnalysisParent,
        selectedTable,
      } = this.Analytics.userSelections;

      Object.assign(this.analyticsPreferences, {
        selected_company: selectedCompanies,
        selected_portfolio: selectedPortfolios,
        selected_commodities: selectedAsset,
        selectedAsset: selectedAsset,
        selectedUnderlying: selectedUnderlying,
        selectedAnalysis: selectedAnalysis,
        selectedAnalysisParent: selectedAnalysisParent,
        selectedTable: selectedTable,
      });
    },
    selectionStr() {
      if (this.isApplyingRoute) return;

      const str = this.Analytics.stringTitle();
      Object.assign(this.Analytics["userSelections"], {
        selectionStr: str,
      });
    },
    onLeftSidebarAnalysisScenarios({ getEvent }) {
      this.eventElement = getEvent;
    },
    onLeftSidebarAnalysis({ val, parent }) {
      Object.assign(this.Analytics["userSelections"], {
        selectedAnalysisParent: parent,
        selectedAnalysis: val,
      });

      if (parent === "contractManagement") {
        Object.assign(this.Analytics["userSelections"], {
          selectedTable: val,
        });
      }
      setTimeout(() => {
        Object.assign(this.Analytics["userSelections"], {
          visibleLeft: false,
        });
      }, 500);

      this.updateRoute();
      this.syncPreferencesFromAnalytics();
      this.saveUserPrefs();
    },
    onUserClickLeftSidebarShow(val) {
      Object.assign(this.Analytics["userSelections"], {
        visibleLeft: val,
      });
    },
    onUserSpotChange(val, resetFwd = false) {
      let _this = this;
      Object.assign(this.Analytics["loading"], {
        topographyCalcs: true,
      });
      this.showLoadingValuating = true;

      if (this.Analytics["rawData"].prevSpot === null) {
        Object.assign(this.Analytics["rawData"], {
          prevSpot: this.Analytics["rawData"].spot,
        });
      }
      Object.assign(this.Analytics["rawData"], {
        spot: val,
      });

      let delta =
        this.Analytics["rawData"].spot / this.Analytics["rawData"].prevSpot;
      Object.assign(this.Analytics["rawData"], {
        prevSpot: val,
      });

      this.Analytics["rawData"].expo.forEach(function(d) {
        if (Math.min(+d["fixation_date"], +d["date"]) > +_this.today) {
          if (resetFwd) {
            if ("fwd_original" in d) {
              d["fwd"] = d["fwd_original"];
            }
          } else {
            if (!("fwd_original" in d)) {
              d["fwd_original"] = +d["fwd"];
            }
            d["fwd"] *= delta;
          }
        }
      });

      if (this.Analytics["rawData"].hedges.length > 0) {
        this.Analytics["rawData"].hedges.forEach(function(d) {
          if (Math.min(+d["hedged_date"], +d["date"]) > +_this.today) {
            if (resetFwd) {
              if ("fwd_original" in d) {
                d["fwd"] = d["fwd_original"];
              }
            } else {
              if (!("fwd_original" in d)) {
                d["fwd_original"] = +d["fwd"];
              }
              d["fwd"] *= delta;
            }
          }
        });
        this.Analytics.postAnalyticsCommodityUpdate(
          this,
          this.Analytics["rawData"]["hedges"],
          this.Analytics["rawData"]["expo"],
        );
      } else {
        this.showLoadingValuating = false;
        Object.assign(this.Analytics["loading"], {
          topographyCalcs: false,
        });
        throw Error("No hedge data raw available");
      }
    },
    onUserFetchExpand() {
      Object.assign(this.Analytics["rawData"], {
        toBeFetchedHidden: !this.Analytics["rawData"]["toBeFetchedHidden"],
      });
    },
    onUserAccountingValuate() {
      this.Analytics.postPortfolioValuation();
    },
    onMktRefChange(val) {
      Object.assign(this.Analytics["userSelections"], { mktRef: val });
      this.Analytics.nestAndZoom(
        this.Analytics["rawData"]["filteredData"],
        false,
      );
      this.Analytics.updateZoomedData();
      this.Analytics.updateZoomedData(true);
    },
    onUserFilterValuation(fltr) {
      Object.assign(this.Analytics["valuation"], {
        dataFilters: fltr,
      });
    },
    onFilteredData(data) {
      Object.assign(this.Analytics["rawData"], {
        filteredData: data,
      });
      this.Analytics.nestAndZoom(data);
      this.Analytics.updateZoomedData();
      this.Analytics.updateZoomedData(true);
    },
    onUserFilter(fltr) {
      Object.assign(this.Analytics["rawData"], {
        dataFilters: fltr,
      });
    },
    onUserSelectUnit(val) {
      Object.assign(this.Analytics["userSelections"], {
        selectedUnit: val,
      });
    },
    onUserCompany(newValue, portfolios = null, assets = null) {
      Object.assign(this.Analytics["valuation"], { valuated: false });
      let saveUserPref = this.Analytics.updateSelectedCompanies(
        newValue,
        portfolios,
        assets,
      );

      if (saveUserPref) {
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }
      this.selectionStr();
      this.updateRoute();
    },

    onUserPortfolio(newValue) {
      Object.assign(this.Analytics["valuation"], { valuated: false });
      Object.assign(this.Analytics["userSelections"], {
        selectedPortfolios: newValue,
      });

      let saveUserPref = this.Analytics.updateSelectedPortf({ initial: false });

      if (saveUserPref) {
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }
      this.selectionStr();
      this.updateRoute();
    },
    // === contract management ===
    onUserAsset(assetId) {
      Object.assign(this.Analytics["valuation"], { valuated: false });
      Object.assign(this.Analytics["userSelections"], {
        selectedAsset: assetId,
        assetsNums: assetId.map((d) => d.pk_id_end_product),
      });
      Object.assign(this.Analytics["rawData"], { toBeFetched: true });

      const saveUserPref = this.Analytics.updateSelectedAsset(null, false);

      if (saveUserPref) {
        this.syncPreferencesFromAnalytics();
        this.saveUserPrefs();
      }
      this.selectionStr();
      this.updateRoute();
    },
    onUserFetchManagementData() {
      Object.assign(this.Analytics["loading"], {
        management: true,
      });
      this.Analytics.getManagementData(
        this,
        this.initCommodityDate,
        this.Analytics["userSelections"]["selectedCompanies"],
        this.Analytics["userSelections"]["selectedAsset"],
        this.Analytics["userSelections"]["selectedPortfolios"],
      );
    },
    onUserFetchData() {
      this.Analytics.getManagementData(
        this,
        this.initCommodityDate,
        this.Analytics["userSelections"]["selectedCompanies"],
        this.Analytics["userSelections"]["selectedAsset"],
        this.Analytics["userSelections"]["selectedPortfolios"],
      );
      this.selectionStr();
    },
    // === valuation ===
    onUserUnderlying(id) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        toBeFetched: true,
      });
      Object.assign(this.Analytics["userSelections"], {
        selectedUnderlying: id,
        underlyingNums: this.Analytics["userSelections"][
          "selectedUnderlying"
        ].map((und) => und.pk_idcommodity),
      });
    },
    onUserFinalDate(finalDate) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        finalDate: finalDate,
        toBeFetched: true,
      });
    },
    onUserFinalSpot(finalSpot) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        finalSpot: finalSpot,
        toBeFetched: true,
      });
    },
    onUserInitialDate(inDate) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        initialDate: inDate,
        toBeFetched: true,
      });
    },
    onUserInitialSpot(initialSpot) {
      Object.assign(this.Analytics["valuation"], {
        valuated: false,
        initialSpot: initialSpot,
        toBeFetched: true,
      });
    },
    // === scenarios
    onClientExpandSidebar(bool) {
      let rBool = this.Analytics["rawData"]["render"];
      Object.assign(this.Analytics["userSelections"], { expandSidebar: bool });
      for (let i = 0; i < 40; i++) {
        setTimeout(() => {
          Object.assign(this.Analytics["rawData"], {
            render: i % 2 === 0 ? !rBool : rBool,
          });
        }, i * 50);
      }
    },
    resizeCharts() {
      let rBool = this.Analytics["rawData"]["render"];
      for (let i = 0; i < 1; i++) {
        setTimeout(() => {
          Object.assign(this.Analytics["rawData"], {
            render: i % 2 === 0 ? !rBool : rBool,
          });
        }, i * 50);
      }
      this.onUserShow();
    },
    handleUserPriceSelection(str, bool) {
      const selections = this.Analytics["userSelections"];
      if (str === "includeFutures") {
        if (selections["includeBasis"] || selections["includeOtherCosts"]) {
          Object.assign(this.Analytics["userSelections"], {
            includeRatio: bool,
          });
        } else {
          if (this.fixing_type != "ratio" && selections["includeRatio"]) {
            Object.assign(this.Analytics["userSelections"], {
              includeRatio: bool,
            });
          }
        }
      }
      if (str === "includeRatio") {
        if (selections["includeBasis"] || selections["includeOtherCosts"]) {
          Object.assign(this.Analytics["userSelections"], {
            includeFutures: bool,
          });
        }
      }
      if (str === "includeBasis") {
        if (this.fixing_type == "ratio") {
          Object.assign(this.Analytics["userSelections"], {
            includeOtherCosts: bool,
          });
        } else if (
          selections.includeFutures &&
          !selections.includeOtherCosts &&
          (bool || (!bool && this.fixing_type != "ratio"))
        ) {
          Object.assign(this.Analytics["userSelections"], {
            includeRatio: bool,
          });
        }
      }
      if (str === "includeOtherCosts") {
        if (this.fixing_type == "ratio") {
          Object.assign(this.Analytics["userSelections"], {
            includeBasis: bool,
          });
          if (selections.includeRatio && bool) {
            Object.assign(this.Analytics["userSelections"], {
              includeFutures: bool,
            });
          } else if (selections.includeFutures && bool) {
            Object.assign(this.Analytics["userSelections"], {
              includeRatio: bool,
            });
          }
        } else if (
          selections.includeFutures &&
          !selections.includeBasis &&
          (bool || (!bool && this.fixing_type != "ratio"))
        ) {
          Object.assign(this.Analytics["userSelections"], {
            includeRatio: bool,
          });
        }
      }
    },
    onUserShow(str) {
      let bool = !this.Analytics["userSelections"][str];
      Object.assign(this.Analytics["userSelections"], {
        [str]: bool,
      });
      if (
        str === "includeFutures" ||
        str === "includeRatio" ||
        str === "includeBasis" ||
        str === "includeOtherCosts"
      ) {
        this.handleUserPriceSelection(str, bool);
      }
      if (str === "showAll" && bool) {
        Object.assign(this.Analytics["userSelections"], {
          showAve: bool,
        });
      }

      if (
        str === "showAve" &&
        bool &&
        !this.Analytics["userSelections"].showAll
      ) {
        Object.assign(this.Analytics["userSelections"], {
          showAll: bool,
        });
      }

      if (str === "showFixedHedged") {
        Object.assign(this.Analytics["userSelections"], {
          showFixedFutures: true,
        });
        Object.assign(this.Analytics["userSelections"], {
          showHedgedFutures: bool,
        });
      }

      if (str === "showAll" || (str === "showAve" && bool)) {
        const sts = [
          "showLCall",
          "showLFwd",
          "showLPut",
          "showSCall",
          "showSFwd",
          "showSPut",
        ];
        for (const subStr of sts) {
          Object.assign(this.Analytics["userSelections"], {
            [subStr]: bool,
          });
        }
      }

      let { includeBasis, includeRatio, includeFutures } = this.Analytics[
        "userSelections"
      ];
      if (
        str === "includeRatio" ||
        str === "includeFutures" ||
        str === "includeBasis"
      ) {
        if (includeFutures) {
          if (includeRatio) {
            if (includeBasis) {
              // futures + ratio + basis
              const fieldsOtherCosts = {
                fldBudget: "budgetP",
                fldBasis: "basisP",
                fldFixed: "fixedP",
                fldMkt: "marketP",
                fldNet: "netP",
                fldFixedPerc: "fixedPPerc",
                fldMktPerc: "marketPPerc",
                fldNetPerc: "netPPerc",
              };
              this.updateUserSelect(fieldsOtherCosts);
            } else {
              // futures + ratio + no basis
              const fieldsWithoutOtherCosts = {
                fldBudget: "budgetPFutRatio",
                fldBasis: "basisPFutRatio",
                fldFixed: "fixedPFutRatio",
                fldMkt: "marketPFutRatio",
                fldNet: "netPFutRatio",
                fldFixedPerc: "fixedPFutRatioPerc",
                fldMktPerc: "marketPFutRatioPerc",
                fldNetPerc: "netPFutRatioPerc",
              };
              this.updateUserSelect(fieldsWithoutOtherCosts);
            }
          } else {
            // futures + no ratio + no basis (no ratio + basis not possible)
            const fieldsWithFuturesOnly = {
              fldBudget: "budgetPFut",
              fldBasis: "basisPFut",
              fldFixed: "fixedPFut",
              fldMkt: "marketPFut",
              fldNet: "netPFut",
              fldFixedPerc: "fixedPFutPerc",
              fldMktPerc: "marketPFutPerc",
              fldNetPerc: "netPFutPerc",
            };
            this.updateUserSelect(fieldsWithFuturesOnly);
          }
        } else {
          if (includeRatio) {
            // no futures + ratio + no basis (basis not possible)
            const fieldsForRatioBasis = {
              fldBudget: "budgetPRatio",
              fldBasis: "fixedPRatio",
              fldFixed: "fixedPRatio",
              fldMkt: "marketPRatio",
              fldNet: "netPRatio",
              fldFixedPerc: "fixedPRatioPerc",
              fldMktPerc: "marketPRatioPerc",
              fldNetPerc: "netPRatioPerc",
            };
            this.updateUserSelect(fieldsForRatioBasis);
          } else {
            if (includeBasis) {
              // no futures + no ratio + basis
              const fieldsForOtherCosts = {
                fldBudget: "budgetPOther",
                fldBasis: "fixedPOther",
                fldFixed: "fixedPOther",
                fldMkt: "marketPOther",
                fldNet: "netPOther",
                fldFixedPerc: "fixedPOtherPerc",
                fldMktPerc: "marketPOtherPerc",
                fldNetPerc: "netPOtherPerc",
              };
              this.updateUserSelect(fieldsForOtherCosts);
            } else {
              // no futures + no ratio + no basis
              const fieldsNull = {
                fldBudget: null,
                fldBasis: null,
                fldFixed: null,
                fldMkt: null,
                fldNet: null,
                fldFixedPerc: null,
                fldMktPerc: null,
                fldNetPerc: null,
              };
              this.updateUserSelect(fieldsNull);
            }
          }
        }
      }
      this.Analytics.updateZoomedData();
      this.Analytics.updateZoomedData(true);

      Object.assign(this.Analytics["rawData"], {
        render: !this.Analytics["rawData"]["render"],
      });
    },
    updateUserSelect(fields) {
      Object.keys(fields).forEach((key) => {
        this.Analytics["userSelections"][key] = fields[key];
      });
    },
    onUserShowDetails() {
      let bool = this.Analytics["userSelections"]["showDetails"];
      Object.assign(this.Analytics["userSelections"], { showDetails: !bool });
    },
    onUserYear(yearNum) {
      let xRange = [
        this.Analytics["rawData"]["years"][yearNum]["initial"],
        this.Analytics["rawData"]["years"][yearNum]["final"],
      ];
      Object.assign(this.Analytics["userSelections"], {
        year: yearNum,
        xZoom: xRange,
      });
      this.zoomAndRender();
    },
    onUserZoom(num) {
      let step;
      let xZoom = this.Analytics["userSelections"].xZoom;
      Object.assign(this.Analytics["userSelections"], { year: null });
      if (num === 1) {
        step = Math.max(0, xZoom[0] - 1);
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [step, xZoom[1]],
        });
      } else if (num === 2) {
        step = Math.min(xZoom[1] - 1, xZoom[0] + 1);
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [step, xZoom[1]],
        });
      } else if (num === 3) {
        step = Math.max(xZoom[0], xZoom[1] - 1);
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [xZoom[0], step],
        });
      } else {
        step = Math.min(
          this.Analytics["rawData"]["nestedData"].length,
          xZoom[1] + 1,
        );
        Object.assign(this.Analytics["userSelections"], {
          xZoom: [xZoom[0], step],
        });
      }
      this.zoomAndRender();
    },
    zoomAndRender() {
      Object.assign(this.Analytics["rawData"], {
        zoomedData: this.Analytics.zoomData(
          this.Analytics["rawData"]["nestedData"],
          this.Analytics["userSelections"]["xZoom"],
        ),
      });
      this.Analytics.filterHedges();
      Object.assign(this.Analytics["rawData"], {
        totals: [this.Analytics.zoomedTotals()],
        render: !this.Analytics["rawData"]["render"],
      });
      this.Analytics.updateZoomedData();
      this.Analytics.updateZoomedData(true);
    },
    onUserNormalizeQty() {
      Object.assign(this.Analytics["userSelections"], {
        normalizeQty: !this.Analytics["userSelections"]["normalizeQty"],
      });
      Object.assign(this.Analytics["rawData"], {
        render: !this.Analytics["rawData"]["render"],
      });
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
  beforeDestroy() {
    selectAll(".tooltip").remove();
  },
};
</script>

<style scoped></style>
